"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuItem = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledMenuItem = _styledComponents.default.div.withConfig({
  displayName: "MenuItemstyles__StyledMenuItem",
  componentId: "sc-1l9ni80-0"
})(["padding:.5rem ", ";.c-menu-item-link-button{font-family:", ";color:", ";position:relative;&:after{border-bottom:3px solid ", ";bottom:-.8rem;content:'';left:-10%;opacity:0;position:absolute;transition:opacity ", " ease;width:120%;}&:hover,&:active{color:", ";text-decoration:none;&:after{opacity:1;}}}@supports (display:grid){&{display:block;width:100%;}@media only screen and (min-width:", "){display:inline-block;padding:0 0 0 2rem;width:auto;}}"], function (props) {
  return props.theme.mobileGutter;
}, function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.noWaitAnimationDuration;
}, function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.maxWidth;
});

exports.StyledMenuItem = StyledMenuItem;